/*
 *
 * ChatDocumentationIndex reducer
 *
 */
import { fromJS } from 'immutable'
import {
  GET_INDEX_STATUS,
  GET_INDEX_STATUS_ERROR,
  GET_INDEX_STATUS_SUCCESS,
  SYNC_INDEX,
  SYNC_INDEX_ERROR,
  SYNC_INDEX_PROGRESS,
  SYNC_INDEX_SUCCESS,
} from './constants'

export const initialState = fromJS({
  status: undefined,
  loading: false,
  error: undefined,
  syncing: false,
  pagesRemaining: undefined,
  synced: false,
  syncError: undefined,
})

function chatDocumentationIndexReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INDEX_STATUS:
      return state.set('loading', true).set('error', undefined)
    case GET_INDEX_STATUS_SUCCESS:
      return state.set('status', fromJS(action.status)).set('loading', false)
    case GET_INDEX_STATUS_ERROR:
      return state.set('error', action.error).set('loading', false)
    case SYNC_INDEX:
      return state
        .set('syncing', true)
        .set('pagesRemaining', undefined)
        .set('synced', false)
        .set('syncError', undefined)
    case SYNC_INDEX_PROGRESS:
      return state.set('pagesRemaining', action.pagesRemaining)
    case SYNC_INDEX_SUCCESS:
      return state.set('syncing', false).set('synced', true)
    case SYNC_INDEX_ERROR:
      return state.set('syncing', false).set('syncError', action.error)
    default:
      return state
  }
}

export default chatDocumentationIndexReducer
